var dlsGray05BgHvr = {
  "&:hover": {
    "backgroundColor": "#53565a !important"
  }
};

export { dlsGray05BgHvr };
